// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import { connect } from 'react-redux'
import { findEntities, findEntityBySysId } from '../../redux/contentful-selectors'
import { brand } from '../../redux/app-selectors'
import Breadcrumbs from '../breadcrumbs.connected'
import Billboard from './index'

import { ContentfulModules, moduleEntity } from '../helpers/modules'
import { RichText, EVEntry } from '../helpers/react'
import { useEntity } from '../helpers/selectors'
import PlatinumBillboard from './platinum'

const BillboardConnected = ({
  breadcrumbs,
  primaryContent,
  primarySlot,
  fullWidthSlot,
  image,
  showImageOnMobile,
  mobileImage,
  variant,
  brand,
}) => {
  const breadcrumbComponent = breadcrumbs && <Breadcrumbs entity={breadcrumbs} variant='light' />
  const primaryContentComponent = primaryContent && <RichText content={primaryContent} />
  const primarySlotComponent = primarySlot && <EVEntry {...moduleEntity(primarySlot)} />
  const fullWidthSlotComponent = fullWidthSlot && <ContentfulModules modules={fullWidthSlot} />
  const imageEntity = useEntity(image)
  const mobileImageEntity = useEntity(mobileImage)

  if (variant === 'platinum') {
    return (
      <PlatinumBillboard
        breadcrumbs={breadcrumbComponent}
        primaryContent={primaryContentComponent}
        primarySlot={primarySlotComponent}
        fullWidthSlot={fullWidthSlotComponent}
        bgImage={imageEntity?.file?.url}
        showImageOnMobile={showImageOnMobile}
        mobileImage={mobileImageEntity?.file?.url}
        brand={brand}
      />
    )
  }

  return (
    <Billboard
      breadcrumbs={breadcrumbComponent}
      primaryContent={primaryContentComponent}
      primarySlot={primarySlotComponent}
      fullWidthSlot={fullWidthSlotComponent}
      bgImage={imageEntity?.file?.url}
      showImageOnMobile={showImageOnMobile}
      mobileImage={mobileImageEntity?.file?.url}
    />
  )
}

export default connect(
  (
    state,
    {
      breadcrumbs,
      primaryContent,
      primarySlot,
      fullWidthSlot,
      image,
      showImageOnMobile,
      mobileImage,
      variant,
    },
  ) => {
    const breadcrumbsEntity = breadcrumbs && findEntityBySysId(state, breadcrumbs.sys.id)
    const primarySlotEntity = primarySlot && findEntityBySysId(state, primarySlot.sys.id)
    const fullWidthSlotEntities = fullWidthSlot && findEntities(state, fullWidthSlot)

    return {
      primaryContent,
      primarySlot: primarySlotEntity,
      fullWidthSlot: fullWidthSlotEntities,
      breadcrumbs: breadcrumbsEntity,
      image,
      showImageOnMobile,
      mobileImage,
      variant,
      brand: brand(state),
    }
  },
)(BillboardConnected)
